import React, { Component } from 'react'
import { ButtonToolbar, Row, Col, Modal, DropdownButton, MenuItem, ButtonGroup, Button } from 'react-bootstrap'
import { toast } from 'react-toastify';

import HSGStudentGrid from './HSGStudentGrid/HSGStudentGrid'
import HSGCard from '../../../Components/HSGCard/HSGCard'
import Phi from '../../../Phi/Phi'
import history from './../../../history'
import CONSTANTS from '../../../Phi/Constants'
import './Student.css'


class Student extends Component {
    constructor(props) {
        super(props)
        this.state = {
            studentArr: [],
            showConfirmationModal: false,
            selectedClass: null,
            selectedStatus: null,

            selectedStudentType: null
        }
    }

    componentWillMount() {
        let organization = JSON.parse(Phi.Storage.getItem('organization'))
        if (organization) {
            if (this.props.currentProgram && Object.keys(this.props.currentProgram).length > 0) {
                let startNode = this.props.currentProgram.billing ? this.props.startNodeMap[this.props.currentProgram.billing.id] : null
                if (startNode) {
                    this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, 
                        inOffset: 0, 
                        inSearchString: '', 
                        inLimit: 100,
                        class: '',
                        section: '',
                        inOffset: 0
                    }))
                }
            }
            else {
                this.props.getProgramByOrganization(organization[0].org_id)
            }

            this.props.getStudentBoardingType(organization[0].org_id)
        }

    }


    componentWillReceiveProps(newProps) {
        if (JSON.stringify(newProps.currentProgram) !== JSON.stringify(this.props.currentProgram) && newProps.currentProgram.billing) {
            let startNode = newProps.startNodeMap[newProps.currentProgram.billing.id]
            this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id }))
        }
    }

    customMultiSelect = props => {
        const { type, checked, disabled, onChange, rowIndex } = props
        return (
            <div className="hsg-checkbox-sm">
                <input
                    type={type}
                    name={'checkbox' + rowIndex}
                    id={'checkbox' + rowIndex}
                    checked={checked}
                    disabled={disabled}
                    onChange={e => onChange(e, rowIndex)}
                    ref={input => {
                        if (input) {
                            input.indeterminate = props.indeterminate;
                        }
                    }}
                />
                <label htmlFor={'checkbox' + rowIndex}>
                    <div className='check'></div>
                </label>
            </div>
        )
    }

    downloadStudentReport = (studentId) => {
        this.props.setLoader()
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        this.props.getStudentReport('health_card', { startNodeId: startNode.id, studentId, type: 'pdf' })
    }

    downloadBulkStudentReport = () => {
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        this.props.getBulkStudentReport('all', { startNodeId: startNode.id, studentArr: this.state.studentArr, type: 'pdf' })
    }

    downloadBulkCBSEStudentReport = () => {
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        this.props.getBulkStudentReport('health_card', { startNodeId: startNode.id, studentArr: this.state.studentArr, type: 'pdf' })
    }

    downloadAllStudentReport = () => {
        this.switchConfirmationModal(false)
        this.props.setLoader()
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        // let studentArr = this.props.studentList.map((student) => student.uuid)
        this.props.getBulkStudentReport('all', { startNodeId: startNode.id, studentArr: this.state.studentArr, type: 'pdf' })
    }

    downloadAllCBSEStudentReport = () => {
        //this.switchConfirmationModal(false)
        this.props.setLoader()
        let startNode = this.props.startNodeMap[this.props.currentProgram.billing.id]
        // let studentArr = this.props.studentList.map((student) => student.hsg_id)
        this.props.getBulkStudentReport('health_card', { startNodeId: startNode.id, studentArr: this.state.studentArr, type: 'pdf' })
    }

    handleSelectAll = (isSelected, rows = []) => {
        let studentArr = this.state.studentArr.slice()
        studentArr = !!isSelected ? rows.filter(row=>row.status>=CONSTANTS.qcCheckedStatusMap.PUBLISHED).map(row => row.uuid) : []
        this.setState({ studentArr })
    }

    onRowSelect = (row, isSelected, e) => {
        let studentArr = this.state.studentArr.slice()
        if (!!isSelected && row.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED) {
            studentArr.push(row.uuid)
        } else {
            let idx = studentArr.indexOf(row.uuid)
            if (idx > -1) {
                studentArr.splice(idx, 1)
            }
        }
        this.setState({
            studentArr,
        })
    }

    searchStudent(param) {
        let studentHeader = Object.assign({}, this.props.studentHeader)
        studentHeader.inSearchString = param;
        this.props.fetchStudentList(studentHeader)
    }

    showNext = where => {
        let { inLimit, inOffset } = this.props.studentHeader
        let { totalStudent, studentHeader } = this.props
        if (where === 'prev') {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit
            this.props.fetchStudentList(Object.assign({}, studentHeader, { inOffset: newOffset }))
        } else {
            if (inOffset >= totalStudent || (inOffset + inLimit) >= totalStudent) {
                return
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchStudentList(Object.assign({}, studentHeader, { inOffset: newOffset }))
        }
    }

    viewReport = () => {
        history.push('/student-list')
    }

    switchConfirmationModal = (val) => this.setState({ showConfirmationModal: Boolean(val) })

    confirmationModal = () => (
        <Modal show={this.state.showConfirmationModal} onHide={() => this.switchConfirmationModal(false)}>
            <Modal.Header>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to download all reports? This might take sometime!</p>
            </Modal.Body>
            <Modal.Footer>
                <button className='hsg-btn-white' onClick={() => this.switchConfirmationModal(false)}>Close</button>
                <button className='hsg-btn' onClick={() => this.downloadAllStudentReport()}>Yes</button>
            </Modal.Footer>
        </Modal>
    )

    fetchNewFilteredList = (newFilter) => {
        let startNode = this.props.currentProgram.billing ? this.props.startNodeMap[this.props.currentProgram.billing.id] : null
        const { selectedClass, selectedSection, selectedStatus, inSearchString, selectedType } = this.state
        if (newFilter) {
            // if (selectedSection && selectedClass) {
            //     startNode && this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, inOffset: 0, inSearchString: inSearchString || '', class: selectedClass, section: selectedSection, isAssessed: selectedStatus }))
            // } else {
            //     startNode && this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, inOffset: 0, inSearchString: inSearchString || '', class: selectedClass, isAssessed: selectedStatus }))
            // }

            startNode && this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, inOffset: 0, inSearchString: inSearchString || '', class: selectedClass, section: selectedSection, isAssessed: selectedStatus, inStudentType: selectedType }))

        } else {
            startNode && this.props.fetchStudentList(Object.assign({}, this.props.studentHeader, { startNode: startNode.id, inOffset: 0, inSearchString: '', class: null, section: null, isAssessed: null, inStudentType: null }))
        }
    }

    addNewFilter = (val, field) => {
        const newFilter = {
            [field]: val
        }
        this.setState({ ...newFilter }, () => this.fetchNewFilteredList(true))
    }

    resetFilter = () => {
        //window.location.reload()
        this.setState({
            selectedClass: null,
            selectedSection: null,
            selectedStatus: null,
            selectedType: null,
            inSearchString: '', 
            inLimit: 100,
            class: '',
            section: '',
            inOffset: 0,
            sortField: null,
            sortBy: null,
        }, () => this.fetchNewFilteredList(false))
    }

    getClasses = (classes, selectedClass, isSmall) => {
        return !isSmall ? [
            <button key={'reset'} className="btn hsg-btn-warning right" onClick={() => this.resetFilter()}>
                Reset
            </button>,
            <div className="right" key={'section'} >
                <DropdownButton title={this.state.selectedSection || "Section"} id='dropdown-for-section' onSelect={data => this.addNewFilter(data, 'selectedSection')}>
                    {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ?
                        classes[selectedClass].map(section => this.state.selectedSection === section ? <MenuItem key={section} eventKey={section} active>{section}</MenuItem> : <MenuItem key={section} eventKey={section}>{section}</MenuItem>)
                        : <MenuItem>{'Please select a class'}</MenuItem>}
                </DropdownButton>
            </div>,
            <div className="right" key={'classes'}>
                <DropdownButton title={this.state.selectedClass || "Class"} id='dropdown-for-class' className="right" onSelect={data => this.addNewFilter(data, 'selectedClass')}>
                    {Object.keys(classes).map(eachClass => this.state.selectedClass === eachClass ? <MenuItem key={eachClass} eventKey={eachClass} active>{eachClass}</MenuItem> : <MenuItem key={eachClass} eventKey={eachClass}>{eachClass}</MenuItem>)}
                </DropdownButton>
            </div>
        ] : (
            <ButtonGroup className='hsg-toolbar'>
                <DropdownButton title={this.state.selectedClass || "Class"} id='dropdown-for-class' onSelect={data => this.addNewFilter(data, 'selectedClass')}>
                    {Object.keys(classes).map(eachClass => this.state.selectedClass === eachClass ? <MenuItem key={eachClass} eventKey={eachClass} active>{eachClass}</MenuItem> : <MenuItem key={eachClass} eventKey={eachClass}>{eachClass}</MenuItem>)}
                </DropdownButton>
                <DropdownButton title={this.state.selectedSection || "Section"} id='dropdown-for-section' onSelect={data => this.addNewFilter(data, 'selectedSection')}>
                    {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ?
                        classes[selectedClass].map(section => this.state.selectedSection === section ? <MenuItem key={section} eventKey={section} active>{section}</MenuItem> : <MenuItem key={section} eventKey={section}>{section}</MenuItem>)
                        : <MenuItem>{'Please select a class'}</MenuItem>}
                </DropdownButton>
                <Button bsStyle="btn hsg-btn-warning-small left" onClick={() => this.resetFilter()}>
                    Reset
                </Button>
            </ButtonGroup>
        )
    }

    getAssessmentFilters = () => {

        let status = [
            {val: "Present", key: true},
            {val: "Absent", key: false}
        ]

        return (
            <div className="right" key={'assessmentStatus'} >
                <DropdownButton 
                    title={this.state.selectedStatus === null ? "Status" : this.state.selectedStatus ? 'Assessed' : 'Not Assessed'} 
                    id='dropdown-for-assessment-status' 
                    onSelect={data => this.addNewFilter(data, 'selectedStatus')}
                >
                    {
                        status.map(
                            section => 
                            this.state.selectedStatus === section.key 
                                ? <MenuItem key={section.val} eventKey={section.key} active>{section.val}</MenuItem> 
                                : <MenuItem key={section.val} eventKey={section.key}>{section.val}</MenuItem>
                        )
                    }
                </DropdownButton>
            </div>
        )
    }

    getStudentTypeFilter = () => {

        const type = this.state.selectedType

        let status = this.props.boardingTypes

        return (
            status && status.length ?
            <div className="right" key={'studentType'} >
                <DropdownButton 
                    title={type || 'Type'}  
                    id='dropdown-for-student-type' 
                    onSelect={data => this.addNewFilter(data, 'selectedType')}
                >
                    {
                        status.map(
                            section => 
                            type === section.types 
                                ? <MenuItem key={section.types} eventKey={section.types} active>{section.types}</MenuItem> 
                                : <MenuItem key={section.types} eventKey={section.types}>{section.types}</MenuItem>
                        )
                    }
                </DropdownButton>
            </div>
            : null
        )
    }
            
    handleDownloadReport = (studentArr) => {
        studentArr.length ? this.downloadBulkStudentReport() : this.switchConfirmationModal(true)
    }

    handleCBSEDownloadReport = (studentArr) => {
        studentArr.length ? this.downloadBulkCBSEStudentReport() : this.downloadAllCBSEStudentReport()
    }

    getToolbarItems = () => {
        return window.innerWidth > 767 ? (
            <ButtonToolbar className ='hsg-toolbar'>
                <button className="btn hsg-btn-consltNow hsg-btn-warning" onClick={() => this.handleDownloadReport(this.state.studentArr && this.state.studentArr.length ? this.state.studentArr : [])}>
                    Download All Reports
                </button>
                <button className="btn hsg-btn-consltNow hsg-btn-warning" onClick={() => this.handleCBSEDownloadReport(this.state.studentArr && this.state.studentArr.length ? this.state.studentArr : [])}>
                    Download CBSE Reports
                </button> 
                <button className="btn hsg-btn-consltNow hsg-btn-primary" onClick={() => this.viewReport()}>
                    View CBSE Reports
                </button>
                {this.getClasses(this.props.classes, this.state.selectedClass)}
                {this.getAssessmentFilters()}
                {this.getStudentTypeFilter()}
            </ButtonToolbar>
        ) : (
            <ButtonToolbar className ='hsg-toolbar'>
                <ButtonGroup>
                    <Button bsStyle="btn hsg-btn-warning-small" onClick={() => this.handleDownloadReport(this.state.studentArr && this.state.studentArr.length ? this.state.studentArr : [])}>
                        Download All Reports
                    </Button>
                    {/* <button className="btn hsg-btn-consltNow hsg-btn-warning" onClick={() => this.switchConfirmationModal(true)}>
                        Download All Reports
                    </button> 
                    <Button bsStyle="btn hsg-btn-primary-small" onClick={() => this.viewReport()}>
                        View All Reports
                    </Button>*/}
                </ButtonGroup>
                {this.getClasses(this.props.classes, this.state.selectedClass, true)}
            </ButtonToolbar>
        )
    }

    render() {
        const { totalStudent, studentHeader, studentList } = this.props
        const { inOffset } = studentHeader
        const selectRowProp = {
            mode: "checkbox",
            clickToSelect: false,
            hideSelectColumn: false,
            onSelect: (row, isSelected, e) => this.onRowSelect(row, isSelected, e),
            customComponent: this.customMultiSelect,
            onSelectAll: this.handleSelectAll
        }

        return (
            <Col lg={12} md={12} sm={12} xs={12}>
                <section className="hsg-student-container" style={{ minHeight: this.props.dim.contentHeight }}>
                    <Row className="show-grid">
                        {/* Toolbar */}
                        <Row className="hsg-toolbar-group">
                            <Col className="hsg-toolbar" xs={12} sm={12} md={12} lg={12}>
                                {this.getToolbarItems()}
                            </Col>
                        </Row>
                        {this.confirmationModal()}
                        {/* Main Content */}
                        <Col md={12} lg={12}>
                            <HSGCard hideHeader={true}>
                                <div className="padding-left-1rem padding-right-1rem">
                                    {
                                        this.props.currentProgram && this.props.currentProgram.billing && this.props.currentProgram.billing.id &&
                                        <HSGStudentGrid
                                            className='hsg-report-table'
                                            offset={inOffset}
                                            data={studentList}
                                            downloadStudentReport={
                                                (studentId) =>
                                                    this.downloadStudentReport(studentId)
                                            }
                                            startNodeId={this.props.startNodeMap[this.props.currentProgram.billing.id].id}
                                            total={totalStudent}
                                            search={(param) => this.searchStudent(param)}
                                            selectRowProp={selectRowProp}
                                            showNext={this.showNext}
                                            inSearchString={this.state.inSearchString}
                                            setSearchString={(e) => this.setState({inSearchString: e})}
                                        />
                                    }
                                </div>
                            </HSGCard>
                        </Col>
                    </Row>
                </section>
            </Col>
        )
    }

}

export default Student


// WEBPACK FOOTER //
// ./src/Containers/StudentContainer/Component/Student.js